module.exports = __webpack_public_path__ + "static/media/timesUpMemory.dfadc054.mp3";